import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { SETTING_TABLE_NAME } from "../../../constants/settingsTableName";
import FortyThreeIForm from "./Form";
import useSettings from "../../../hooks/useSettings";

const FortyThreeISetting = () => {
  const { t } = useTranslation("common");
  const { formState, loading, error, fetchSettings } =
    useSettings(SETTING_TABLE_NAME.DEVICE_43I_SETTINGS, (res) => res);

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>43i</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>
            {t("No Settings Found")}
          </Typography>
        )}
        {!loading && formState && <FortyThreeIForm settings={formState} />}
      </AccordionDetails>
    </Accordion>
  );
};

export default FortyThreeISetting;
